
import { useRef } from "react";

export function useOpenerFocus() {
  const openerRef = useRef<HTMLElement | null>(null);

  return {
    rememberOpener: () => {
      openerRef.current = document.activeElement as HTMLElement | null;
    },
    returnFocusToOpener: (event: Event) => {
      const opener = openerRef.current;
      if (!opener || !opener.isConnected) return;
      event.preventDefault();
      opener.focus();
    },
  };
}
